import { LoadingSpinner } from '@tvg/fuse-design/loading-spinner';
import { gridConfig } from '@tvg/fuse-design/responsive-grid';
import useIsUpdating from 'client/hooks/useIsUpdating';
import React from 'react';
import styled from 'styled-components';

const TransparentBlack = styled.div.attrs({
  className: 'transparent-black-cover',
})`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: var(--color-base-black);
  opacity: 0.2;
  z-index: 99999;
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

const WhiteSquare = styled.div`
  position: fixed;
  display: inline-flex;
  padding: var(--spacing-space24);
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: var(--border-width-xs) solid var(--grey-grey-300);
  background: var(--color-base-white);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    padding: var(--spacing-space32);
  }
`;

export function Spinner() {
  const isUpdating = useIsUpdating();

  if (!isUpdating) return null;
  return (
    <>
      <TransparentBlack />
      <Container>
        <WhiteSquare>
          <LoadingSpinner size="responsive" animationTime={1} />
        </WhiteSquare>
      </Container>
    </>
  );
}
